import { createFileRoute } from "@tanstack/react-router";
import WhatIsPersonalizedTmsTargeting from "@/pages/articles/WhatIsPersonalizedTmsTargeting";
export const Route = createFileRoute("/what-is-personalized-tms-targeting")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Is Personalized TMS Targeting | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What is personalized TMS targeting? Learn how fMRI guides SAINT TMS to your brain’s unique circuits in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "What Is Personalized TMS Targeting | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What is personalized TMS targeting? Learn how fMRI guides SAINT TMS to your brain’s unique circuits in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-is-personalized-tms-targeting",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-personalized-tms-targeting",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsPersonalizedTmsTargeting />;
}
